import {SpinnerService} from "../../modules/SpinnerModule";
import * as angular from "angular";
import {DataHubService} from "../../modules/DataHubModule";
import {IQService} from "angular";
import {CustomerSearchDto} from "../../model/CustomerSearchDto";
import {XheoActivationDto} from "../../model/XheoActivationDto";

export class ManageController {
    asset = null;
    assetModel = null;
    assetLicenses = [];
    assetNotes = [];
    assetTransactions = [];
    assetEnabledFeatures = [];
    assetEmailLogs = [];
    assetGuid = null;
    assetPricePlans = [];
    assetProducts = [];
    assetStatus = [];
    assetTypes = [];
    licenseModel = null;
    noteModel = null;
    txnModel = null;
    customerSearchRequestId = 0;
    customerSearchResults: CustomerSearchDto[] = [];
    private assetActivations: XheoActivationDto[] = [];

    constructor(private $dataHub: DataHubService,
                private $q: IQService,
                private $spinner: SpinnerService,
                private $state,
                private $stateParams: any) {

        $dataHub.client.onAssetUpdated(e => this.asset = e);
        $dataHub.client.onAssetRemoved(() => window.close());

        $dataHub.client.bindAllAssetActivation(() => this.assetActivations);
        $dataHub.client.bindAllAssetEmailLog(() => this.assetEmailLogs);
        $dataHub.client.bindAllAssetLicense(() => this.assetLicenses);
        $dataHub.client.bindAllAssetNote(() => this.assetNotes);
        $dataHub.client.bindAllAssetPricePlan(() => this.assetPricePlans);
        $dataHub.client.bindAllAssetProduct(() => this.assetProducts);
        $dataHub.client.bindAllAssetStatus(() => this.assetStatus);
        $dataHub.client.bindAllAssetTransaction(() => this.assetTransactions);
        $dataHub.client.bindAllAssetType(() => this.assetTypes);

        $dataHub.client.onCustomerSearchResult((rid, e) => {
            if (rid != this.customerSearchRequestId) return;
            this.customerSearchResults.merge(e, x => x.guid);
        });

        $dataHub.onConnected(this.refresh)

    }


    refresh = () => {
        console.debug('stateParams', this.$stateParams);
        this.$dataHub.server.assetPricePlanSub();
        this.$dataHub.server.assetProductSub();
        this.$dataHub.server.assetStatusSub();
        this.$dataHub.server.assetTypeSub();

        var guid = this.$stateParams.assetGuid;
        if (!guid && this.$stateParams.create) {
            return this.createNew();
        }
        this.$spinner.show('Loading');
        this.$q.all([
            this.$dataHub.server.assetSub(guid),
            this.$dataHub.server.assetActivationSub(guid),
            this.$dataHub.server.assetEmailLogSub(guid),
            this.$dataHub.server.assetEnabledFeatureSub(guid),
            this.$dataHub.server.assetLicenseSub(guid),
            this.$dataHub.server.assetNoteSub(guid),
            this.$dataHub.server.assetTransactionSub(guid),
        ])
            .then(e => console.log('done', e))
            .catch(e => console.error(e))
            .finally(() => this.$spinner.hide());
    };


    createNew = () => {
        this.assetModel = {};
    };

    getTxnDesc = (txn) => {
        let x = '';
        let seats = Math.abs(txn.addSeats) === 1 ? 'seat' : 'seats';
        let renewSeats = Math.abs(txn.renewSeats) === 1 ? 'seat' : 'seats';

        if (txn.addSeats < 0)
            x += `Drop ${Math.abs(txn.addSeats)} ${seats}\n`;

        if (txn.addSeats > 0)
            x += `Add ${Math.abs(txn.addSeats)} ${seats} for ${txn.years}Y ${txn.months}M ${txn.days}D\n`;

        if (txn.renewSeats > 0)
            x += `Renew ${txn.renewSeats} ${renewSeats} for ${txn.years}Y ${txn.months}M ${txn.days}D\n`;

        return x.trim();
    };

    assetEdit = () => {
        this.assetModel = angular.copy(this.asset);
    };

    assetSave = () => {
        this.$spinner.show('Saving');
        this.$dataHub.server.assetSave(this.assetModel)
            .then(guid => {
                this.assetModel = null;
                if (!this.$stateParams.assetGuid) {
                    this.$state.go('.', {assetGuid: guid});
                    this.refresh();
                }
            })
            .catch(e => {
                console.error(e);
                alert(e);
            })
            .finally(() => this.$spinner.hide());
    };

    validateAsset = () => {
        this.$spinner.show('Validating');
        this.$dataHub.server.assetValidate(this.asset.guid)
            .catch(e => {
                console.error(e);
                alert(e);
            })
            .finally(() => this.$spinner.hide());
    };

    noteSave = () => {
        var data = {
            asset: this.asset,
            noteText: this.noteModel.noteText
        };
        this.$spinner.show('Saving');
        this.$dataHub.server.assetNoteSave(data)
            .then(() => this.noteModel = null)
            .catch(e => {
                console.error(e);
                alert(e);
            })
            .finally(() => this.$spinner.hide());
    };

    activationDelete = (activation: XheoActivationDto) => {
        this.$spinner.show('Deleting');
        this.$dataHub.server.assetActivationDelete(activation)
            .catch(e => {
                console.error(e);
                alert(e);
            })
            .finally(() => this.$spinner.hide());
    };
    activationReset = (activation: XheoActivationDto) => {
        this.$spinner.show('Resetting');
        this.$dataHub.server.assetActivationReset(activation)
            .catch(e => {
                console.error(e);
                alert(e);
            })
            .finally(() => this.$spinner.hide());
    };

    licenseSave = () => {
        if (!this.licenseModel.asset)
            this.licenseModel.asset = this.asset;
        this.$spinner.show('Saving');
        this.$dataHub.server.assetLicenseSave(this.licenseModel)
            .then(() => this.licenseModel = null)
            .catch(e => {
                console.error(e);
                alert(e);
            })
            .finally(() => this.$spinner.hide());
    };

    txnCreate = () => {
        this.txnModel = {
            txnDate: new Date(),
            pricePlan: this.asset.pricePlan
        };
    };

    txnSave = () => {
        if (!this.txnModel.asset)
            this.txnModel.asset = this.asset;
        this.$spinner.show('Saving');
        this.$dataHub.server.assetTransactionSave(this.txnModel)
            .then(() => this.txnModel = null)
            .catch(e => {
                console.error(e);
                alert(e);
            })
            .finally(() => this.$spinner.hide());
    };

    customerSearch = (input) => {
        this.customerSearchRequestId++;
        this.customerSearchResults = [];
        this.$dataHub.server.customerJobSearch(this.customerSearchRequestId, input, 10);
    }

}
